// import React, 'react';
import { useEffect, useState, useRef } from 'react';
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from 'react-toastify';
import html2canvas from "html2canvas";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Swal from 'sweetalert2';
import { loadFontAsBase64 } from "../loadFont";

// You will need a library to generate QR codes. Install it using: npm install qrcode
import QRCode from 'qrcode';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { parse } from "node-html-parser"; 
import MachineResultImport from './MachineResultImport';

// मैंने आपके CSS को सीधे यहां स्टाइल ऑब्जेक्ट में डाल दिया है ताकि यह एक ही फाइल में रहे।
// आप इसे अपनी CSS फाइल में भी रख सकते हैं।
const styles = `
    .report-entry-container {
      background-color: #f0f2f5;
      border-radius: 8px;
    }
    .patient-details-card {
      background-color: #ffffff;
      border: 1px solid #dee2e6;
      border-radius: 5px;
      padding: 1rem;
    }
    .patient-details-card .table td {
      padding: 0.25rem 0.5rem;
      font-size: 0.9rem;
      border: none;
    }
    .patient-details-card .table strong {
      min-width: 90px;
      display: inline-block;
      color: #495057;
    }
    .report-table {
      background-color: #ffffff;
    }
    .report-table .table-header-blue {
      background-color: #405189;
      color: white;
    }
    .report-table th, .report-table td {
      vertical-align: middle;
      text-align: left;
      padding: 0.75rem;
    }
    .report-table .form-control {
      border: 1px solid #ced4da;
      border-radius: 4px;
      height: auto;
      padding: 0.375rem 0.75rem;
    }
    .nav-tabs .nav-link {
        color: #495057;
        border-bottom-width: 2px;
    }
    .nav-tabs .nav-link.active {
      color: #405189;
      border-color: #405189 #405189 #fff;
      font-weight: 600;
    }
      /* Accordion-style Investigation Section */
.investigation-section-accordion .accordion-item {
  border: 1px solid #dee2e6;
  border-radius: 5px;
  margin-bottom: 10px;
  background-color: #fff;
}

.investigation-section-accordion .accordion-header {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  gap: 15px;
}

.investigation-section-accordion .accordion-toggle-btn {
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 1;
  padding: 0 10px;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  color: #28a745; /* Green color for '+' */
}

.investigation-section-accordion .accordion-toggle-btn.active {
    color: #dc3545; /* Red color for '-' */
}

.investigation-section-accordion .accordion-title {
  flex-grow: 1;
  font-weight: 500;
  color: #495057;
}

.investigation-section-accordion .accordion-body {
  padding: 15px;
  border-top: 1px solid #dee2e6;
  background-color: #f8f9fa;
}
.zindex-dropdown {
    z-index: 1050;
}



`;


const ReportEntry = () => {
  

  const stripAsterisks = (s) => {
    const str = String(s || '').trim();
    if (/^\*.+\*$/.test(str)) return str.replace(/^\*(.+)\*$/, '$1');
    return str;
  }; 
  
const [showPrintPopup, setShowPrintPopup] = useState(false);
const [printType, setPrintType] = useState("with"); // "with" or "without"
const [pendingPrintAction, setPendingPrintAction] = useState(null);
// add this near other state declarations
// add near other states
const [patientsLoading, setPatientsLoading] = useState(false);
const [patientPage, setPatientPage] = useState(0);
const PATIENTS_PER_PAGE = 20;
// Add near other helpers
// Add near other helpers
const resolveTestId = (test) => {
  // ✅ Prioritize lab_item_id for unique instance identification
  return test?.lab_item_id ?? test?.lab_item_test_id ?? test?.lab_item_parent ?? test?.id ?? null;
};

// ===== Add near other state declarations =====
const [selectedTests, setSelectedTests] = useState(new Set()); // stores lab_item_test_id
const [selectAllTests, setSelectAllTests] = useState(false);

// Toggle a single test selection
// Toggle a single test selection
const handleToggleTestSelect = (testOrId) => {
  // ✅ Use lab_item_id for unique identification
  const id = typeof testOrId === 'object' ? testOrId.lab_item_id : testOrId;
  if (!id) return;

  setSelectedTests(prev => {
    const next = new Set(prev);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    return next;
  });
};

// Select / deselect all visible tests
const handleToggleSelectAll = () => {
  if (selectAllTests) {
    setSelectedTests(new Set());
    setSelectAllTests(false);
  } else {
    // ✅ Use lab_item_id
    const allIds = new Set((formData.l11 || []).map(t => t.lab_item_id).filter(Boolean));
    setSelectedTests(allIds);
    setSelectAllTests(true);
  }
};

// Build array of test objects from selectedTests
const getSelectedTestsArray = () => {
  if (!formData.l11) return [];
  // ✅ Use lab_item_id for matching
  return formData.l11.filter(t => selectedTests.has(t.lab_item_id));
};
// const handleApproveTest = async (testReportId) => {
//   // ✅ ADD VALIDATION
//   if (!testReportId) {
//     toast.error("Please save the report first before approving!");
//     return;
//   }

//   const confirm = await Swal.fire({
//     title: "Approve this test?",
//     icon: "question",
//     showCancelButton: true,
//     confirmButtonText: "Approve"
//   });

//   if (!confirm.isConfirmed) return;

//   const fd = new FormData();
//   fd.append("test_report_id", testReportId);
//   fd.append("approved_by", ldata.user_id);
//   fd.append("approved_by_name", Name);

//   try {
//     const res = await axios.post(
//       AppConst.BASE_URL + AppConst.approveTestReportUrl,
//       fd,
//       {
//         headers: { "Content-Type": "multipart/form-data" }
//       }
//     );

//     if (res.data.status) {
//       toast.success("Test approved successfully");

//       // ✅ UPDATE STATE CORRECTLY
//       setFormData(prev => ({
//         ...prev,
//         l11: prev.l11.map(t =>
//           String(t.report_info?.test_report_id) === String(testReportId)
//             ? {
//                 ...t,
//                 report_info: {
//                   ...t.report_info,
//                   is_approved: "1",
//                   approved_by_name: Name,
//                   approved_by: ldata.user_id,
//                   approval_datetime: new Date().toISOString()
//                 }
//               }
//             : t
//         )
//       }));
//     } else {
//       toast.error("Failed to approve test");
//     }
//   } catch (error) {
//     console.error("Approve error:", error);
//     toast.error("Error approving test");
//   }
// };

// Select / deselect all visible tests

// Add these helper functions near the top of the component (after state declarations)

// Helper function to check if a test is radiology
// Helper function to check if a test is radiology
const isRadiologyTest = (test) => {
  if (!test) return false;
  
  // ✅ Check from main record test_cat (from backend join)
  if (test.test_cat) {
    return String(test.test_cat) === '60';
  }
  
  // ✅ Check from params (fallback)
  if (test.params && test.params.length > 0) {
    const testCat = String(test.params[0]?.test_cat || '');
    if (testCat === '60') return true;
  }
  
  // ✅ Check from lab_item_test_cat if available
  if (test.lab_item_test_cat) {
    return String(test.lab_item_test_cat) === '60';
  }
  
  return false;
};

// Helper function to filter tests based on role
const filterTestsByRole = (tests, roleId) => {
  if (!Array.isArray(tests)) return [];
  
  const role = String(roleId);
  
  // Admin (role_id = 1) - show all tests
  if (role === '1') {
    return tests;
  }
  
  // Radiologist (role_id = 11) - show only radiology tests
  if (role === '11') {
    return tests.filter(test => isRadiologyTest(test));
  }
  
  // Pathologist (role_id = 3) - show all EXCEPT radiology
  if (role === '3') {
    return tests.filter(test => !isRadiologyTest(test));
  }
  
  // Default: show all tests (for other roles)
  return tests;
};

const handleApproveTest = async (testReportId, labItemId) => {
  if (!testReportId) {
    toast.error("Please save the report first before approving!");
    return;
  }

  const confirm = await Swal.fire({
    title: "Approve this test?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Approve"
  });

  if (!confirm.isConfirmed) return;

  const fd = new FormData();
  fd.append("test_report_id", testReportId);
  fd.append("approved_by", ldata.user_id);
  fd.append("approved_by_name", Name);

  try {
    const res = await axios.post(
      AppConst.BASE_URL + AppConst.approveTestReportUrl,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    if (res.data.status) {
      toast.success("Test approved successfully");

      // ✅ UPDATE STATE - Match by lab_item_id for accuracy
      setFormData(prev => ({
        ...prev,
        l11: prev.l11.map(t =>
          String(t.lab_item_id) === String(labItemId)
            ? {
                ...t,
                report_info: {
                  ...t.report_info,
                  is_approved: "1",
                  approved_by_name: Name,
                  approved_by: ldata.user_id,
                  approval_datetime: new Date().toISOString()
                }
              }
            : t
        )
      }));
    } else {
      toast.error("Failed to approve test");
    }
  } catch (error) {
    console.error("Approve error:", error);
    toast.error("Error approving test");
  }
};








const [todaysPatients, setTodaysPatients] = useState([]);

   const [Name, setName] = useState('');

       const [image, setImage] = useState('')
       const [watermarkImage, setWatermarkImage] = useState('');
       const [footerImage, setFooterImage] = useState('');
    const [isReportSaved, setIsReportSaved] = useState(false);
    const [searchKey, setSearchKey] = useState('');
    const [filteredPatients, setFilteredPatients] = useState([]);

    const totalPatientPages = Math.ceil((filteredPatients?.length || 0) / PATIENTS_PER_PAGE);
const paginatedPatients = (filteredPatients || []).slice(
  patientPage * PATIENTS_PER_PAGE,
  (patientPage + 1) * PATIENTS_PER_PAGE
);
    const [showSearchDropdown, setShowSearchDropdown] = useState(false);
    const inputRef = useRef();
    const dropdownRef = useRef();

    const [activeIndex, setActiveIndex] = useState(0);

      const htmlRef = useRef();
    const [formData, setFormData] = useState({
        test_id: "",
        test_id0: "",
        test_id1: "",
        test_id2: "",
        l1: [],
        l11: [],
        l2: [],
        l3: [],
        test_report_impression: '',
        test_report_datetime: "",
        test_report_notes: '',
        test_report_patient: '',
        test_report_user: '',
        page_no: 0,
        from: '',
        to: '',
        search_key: '',
        departs: [],
        selItem :{}
    });
    const [selectedUser, setSelectedUser] = useState(null);
    const [ldata, setLdata] = useState(null);


// collapsed-by-default toggle state for Additional Notes per test index
const [openNotes, setOpenNotes] = useState({});

const toggleNotes = (index) => {
  setOpenNotes(prev => ({ ...prev, [index]: !prev[index] }));
};

useEffect(() => {
    const now = new Date();

    const formattedDateTime = now.toLocaleString("en-GB", { 
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit", hour12: false
  }).replace(/\//g, "-"); // ✅ slash ko dash me badalna

  const isoNow = new Date().toISOString();

setFormData(prev => ({
  ...prev,
  from: formatDateForInput(now),   // YYYY-MM-DD for input
  to: formatDateForInput(now),
  // store as ISO so formatDateTime12h can parse correctly in all browsers
  test_report_datetime: isoNow
}));




const storedData = sessionStorage.getItem("ldata");
  if (storedData) {
    const parsed = JSON.parse(storedData);
    setLdata(parsed);
    const today = new Date();
    getTests(parsed.user_id, today, today, true); // onlyToday=true -> stores today's list but no auto-select
  }
}, []);



useEffect(() => {
  // clear selection when tests list changes or patient changes
  setSelectedTests(new Set());
  setSelectAllTests(false);
}, [formData.test_id0,selectedUser]);

// helper to convert Date or date-string to YYYY-MM-DD
const toYMD = (d) => {
  if (!d) return '';
  const dt = (d instanceof Date) ? d : new Date(d);
  if (isNaN(dt.getTime())) return '';
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, '0');
  const day = String(dt.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

const getTests = async (userId, fromDate, toDate, onlyToday = false) => {
  if (!userId) return;

  if (!onlyToday) {
    const fromY = parseToYMD(fromDate);
    const toY = parseToYMD(toDate);
    if (!fromY || !toY) {
      console.info("getTests: skipping fetch because date range missing. Use Search button to fetch historical data.");
      return;
    }
  }

  setPatientsLoading(true);

  const fd1 = new FormData();
  fd1.append('page_no', "none");
  fd1.append('search_key', "");
  // ADD THESE TWO LINES (important)
  const fromY = parseToYMD(fromDate) || formatDateForInput(new Date());
  const toY   = parseToYMD(toDate)   || formatDateForInput(new Date());
  fd1.append('from', fromY);
  fd1.append('to', toY);

  try {
    const response = await axios.post(AppConst.BASE_URL + AppConst.getLabRegListItmUrl, fd1, {
      headers: { 'Content-Type': 'multipart/form-data' },
      //timeout: 20000
    });
    

    if (response.data.status && Array.isArray(response.data.records)) {
      const normalized = response.data.records.map(rec => {
        let interp = (rec.interpretation && String(rec.interpretation).trim()) ? rec.interpretation : "";

        if (!interp && rec.test_interpretation) interp = rec.test_interpretation;
        if (!interp && rec.test_interpratation) interp = rec.test_interpratation;

        if (!interp && Array.isArray(rec.params) && rec.params.length > 0) {
          for (const p of rec.params) {
            if (p.test_interpretation && String(p.test_interpretation).trim()) { interp = p.test_interpretation; break; }
            if (p.test_interpratation && String(p.test_interpratation).trim()) { interp = p.test_interpratation; break; }
            if (p.test_interpretation_html && String(p.test_interpretation_html).trim()) { interp = p.test_interpretation_html; break; }
          }
        }

        return { 
          ...rec, 
          interpretation: interp ? String(interp) : "",
          report_info: rec.report_info || {
            test_report_id: rec.test_report_id || null,
            is_approved: rec.is_approved || "0",
            approved_by: rec.approved_by || null,
            approved_by_name: rec.approved_by_name || null,
            approval_datetime: rec.approval_datetime || null
          }
        };
      });
      

      // store raw list
      setFormData(prev => ({ ...prev, l1: normalized }));

      const uniquePatientsList = [...new Map(normalized.map(item => [item['lab_reg_id'], item])).values()];

      if (onlyToday) {
        const reqDateStr = toYMD(fromDate);
        const todays = uniquePatientsList.filter(p => {
          const pDateStr = toYMD(p.lab_reg_date || p.lab_reg_datetime || p.lab_reg_date_time || p.lab_reg_dt);
          return pDateStr && reqDateStr && pDateStr === reqDateStr;
        });

        setTodaysPatients(todays);
        setFilteredPatients(todays);
      } else {
        // full range
        setFilteredPatients(uniquePatientsList);
        setTodaysPatients([]);
        setSearchKey('');
        setSelectedUser(null);
        setFormData(prev => ({ ...prev, test_id0: '', l11: [] }));
      }
    } else {
      setFormData(prev => ({ ...prev, l1: [] }));
      setFilteredPatients([]);
      setTodaysPatients([]);
      setSearchKey('');
      setSelectedUser(null);
      setFormData(prev => ({ ...prev, test_id0: '', l11: [] }));
    }
  } catch (error) {
    console.error("getTests error:", error);
    toast.error("Failed to fetch test data.");
  } finally {
    setTimeout(() => setPatientsLoading(false), 150);
  }
};

const searchBackend = async (searchValue) => {
  if (!searchValue || searchValue.trim().length < 2) return;
  if (!ldata?.user_id) return;

  try {
    const fd1 = new FormData();
    fd1.append('page_no', "none");
    fd1.append('search_key', searchValue.trim());
    // ✅ Don't send from/to — backend will skip date filter when search_key is present

    const response = await axios.post(
      AppConst.BASE_URL + AppConst.getLabRegListItmUrl,
      fd1,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );

    if (response.data.status && Array.isArray(response.data.records)) {
      const normalized = response.data.records.map(rec => ({
        ...rec,
        interpretation: rec.interpretation || "",
        report_info: rec.report_info || {
          test_report_id: null, is_approved: "0",
          approved_by: null, approved_by_name: null, approval_datetime: null
        }
      }));

      // ✅ Merge with existing l1 (don't replace — add new ones)
      setFormData(prev => {
        const existingMap = new Map(prev.l1.map(item => [item.lab_item_id, item]));
        normalized.forEach(rec => {
          if (!existingMap.has(rec.lab_item_id)) {
            existingMap.set(rec.lab_item_id, rec);
          }
        });
        return { ...prev, l1: [...existingMap.values()] };
      });

      // ✅ Update filtered list from search results
      const uniqueSearchResults = [...new Map(normalized.map(item => [item.lab_reg_id, item])).values()];
      setFilteredPatients(uniqueSearchResults);
    }
  } catch (err) {
    console.error("searchBackend error:", err);
  }
};


  
  
  // keep filtered/today lists in sync whenever l1 updates
  useEffect(() => {
    const uniq = [...new Map((formData.l1 || []).map(item => [item.lab_reg_id, item])).values()];
  
    // ✅ Only update filteredPatients if user is NOT actively searching
    // If searchKey has a value, the search results should stay — don't overwrite
    if (!searchKey || searchKey.trim() === '') {
      setFilteredPatients(uniq);
    }
  
    // build today's list (always update this)
    const reqDateStr = formData.from ? parseToYMD(formData.from) : formatDateForInput(new Date());
    const todays = uniq.filter(p => {
      const pDateStr = toYMD(p.lab_reg_date || p.lab_reg_datetime || p.lab_reg_date_time || p.lab_reg_dt);
      return pDateStr && reqDateStr && pDateStr === reqDateStr;
    });
    setTodaysPatients(todays);
  }, [formData.l1, formData.from]);


  // ✅ NEW: Handle prefill from Lab Registrations page
useEffect(() => {
  // Wait until ldata is loaded
  if (!ldata?.user_id) return;

  const raw = sessionStorage.getItem('report_entry_prefill');
  if (!raw) return;

  try {
    const prefill = JSON.parse(raw);
    if (!prefill || !prefill.lab_reg_uhid) {
      sessionStorage.removeItem('report_entry_prefill');
      return;
    }

    // Stale check — ignore if older than 2 minutes
    if (prefill.timestamp && (Date.now() - prefill.timestamp > 2 * 60 * 1000)) {
      sessionStorage.removeItem('report_entry_prefill');
      return;
    }

    console.log("[ReportEntry] Prefill detected:", prefill);

    // Step 1: Put the UHID/name in the search box
    const searchText = `${prefill.lab_reg_name || ''} (${prefill.lab_reg_uhid})`;
    setSearchKey(searchText);

    // Step 2: Trigger backend search so we get fresh data
    (async () => {
      try {
        setPatientsLoading(true);

        const fd1 = new FormData();
        fd1.append('page_no', 'none');
        fd1.append('search_key', prefill.lab_reg_uhid); // search by UHID for exact match

        const response = await axios.post(
          AppConst.BASE_URL + AppConst.getLabRegListItmUrl,
          fd1,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );

        if (response.data.status && Array.isArray(response.data.records) && response.data.records.length > 0) {
          const normalized = response.data.records.map(rec => ({
            ...rec,
            interpretation: rec.interpretation || '',
            report_info: rec.report_info || {
              test_report_id: rec.test_report_id || null,
              is_approved: rec.is_approved || "0",
              approved_by: rec.approved_by || null,
              approved_by_name: rec.approved_by_name || null,
              approval_datetime: rec.approval_datetime || null
            }
          }));

          // Merge into l1
          setFormData(prev => {
            const existingMap = new Map(prev.l1.map(item => [item.lab_item_id, item]));
            normalized.forEach(rec => {
              if (!existingMap.has(rec.lab_item_id)) {
                existingMap.set(rec.lab_item_id, rec);
              }
            });
            return { ...prev, l1: [...existingMap.values()] };
          });

          // Find the matching patient record
          const matchedPatient = normalized.find(
            r => String(r.lab_reg_uhid) === String(prefill.lab_reg_uhid) &&
                 String(r.lab_reg_id) === String(prefill.lab_reg_id)
          ) || normalized.find(
            r => String(r.lab_reg_uhid) === String(prefill.lab_reg_uhid)
          );

          if (matchedPatient) {
            // Small delay so state settles before we call handlePatientSelect
            setTimeout(() => {
              handlePatientSelect(matchedPatient);
              toast.success(`Loaded report for ${matchedPatient.lab_reg_name}`);
            }, 200);
          } else {
            toast.warning("Patient found but no test records available");
          }
        } else {
          toast.error("No test records found for this UHID");
        }
      } catch (err) {
        console.error("[ReportEntry] Prefill fetch error:", err);
        toast.error("Failed to load patient for report entry");
      } finally {
        setPatientsLoading(false);
        // ✅ Clean up so it doesn't re-trigger
        sessionStorage.removeItem('report_entry_prefill');
      }
    })();
  } catch (err) {
    console.error("[ReportEntry] Prefill parse error:", err);
    sessionStorage.removeItem('report_entry_prefill');
  }
}, [ldata?.user_id]); // ✅ Run when ldata is ready


const _fetchInFlight = {}; // map testId => true
const fetchedParamIdsRef = useRef(new Set());

const fetchTestParams = async (testId, labItemId) => {
  if (!testId) return;

  // ⛔ Use lab_item_id as the unique key for tracking fetched params
  const uniqueKey = labItemId || testId;
  
  if (fetchedParamIdsRef.current.has(uniqueKey)) {
    return;
  }

  fetchedParamIdsRef.current.add(uniqueKey);

  try {
    const fd = new FormData();
    fd.append('page_no', "none");
    fd.append('search_key', "");
    fd.append('test_id', testId); // Use test_id to fetch param definitions

    const response = await axios.post(
      AppConst.BASE_URL + AppConst.getTestParamListUrl,
      fd,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );

    const records = Array.isArray(response.data.records)
      ? response.data.records.map(p => ({ ...p, result: '' }))
      : [];

    // ✅ FIXED: Match by lab_item_id (unique instance) instead of lab_item_test_id
    setFormData(prev => ({
      ...prev,
      l11: prev.l11.map(t => {
        // Use lab_item_id for unique identification
        if (String(t.lab_item_id) === String(labItemId)) {
          // Only update params if they don't already have results
          // This preserves loaded results from database
          if (Array.isArray(t.params) && t.params.length > 0 && t.params.some(p => p.result)) {
            return t; // Keep existing params with results
          }
          return { ...t, params: records };
        }
        return t;
      })
    }));
  } catch (err) {
    console.error("fetchTestParams error", err);
  }
};




const handleSubmit = async (e) => {
  e.preventDefault();

  if (!selectedUser) {
      toast.error("Please fill required fields.");
      return;
  }

  // ✅ FIXED: Include lab_item_id for unique identification
  const processedL11 = formData.l11.map(test => {
    const newParams = test.params.map(param => ({
      ...param,
      result: param.result && param.result.trim() !== "" ? param.result : null
    }));

    return {
      ...test,
      lab_item_id: test.lab_item_id, // ✅ Include unique instance ID
      lab_item_test_id: test.lab_item_test_id,
      params: newParams
    };
  });

  const fd = new FormData();
  fd.append('test_report_impression', formData.test_report_impression);
  fd.append('test_report_notes', formData.test_report_notes);
  fd.append('test_report_datetime', formData.test_report_datetime);
  fd.append('lab_reg_id', selectedUser.lab_reg_id);
  fd.append('items', JSON.stringify(processedL11));
  fd.append('test_report_user', ldata?.user_id);

  try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.addTestReportUrl, fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (response.data.status) {
          setIsReportSaved(true);
          toast.success("Report created successfully!");
          sessionStorage.removeItem("tst_dt");

          // ✅ UPDATE STATE WITH RETURNED test_report_ids - Match by lab_item_id
          const savedReports = response.data.records || [];
          
          if (Array.isArray(savedReports) && savedReports.length > 0) {
              setFormData(prev => ({
                  ...prev,
                  l11: prev.l11.map(test => {
                      // ✅ Match by lab_item_id (unique) instead of lab_item_test_id
                      const savedReport = savedReports.find(
                          r => String(r.lab_item_id) === String(test.lab_item_id)
                      );
                      
                      if (savedReport && savedReport.test_report_id) {
                          return {
                              ...test,
                              report_info: {
                                  ...test.report_info,
                                  test_report_id: savedReport.test_report_id,
                                  is_approved: savedReport.is_approved || "0",
                                  approved_by: savedReport.approved_by || null,
                                  approved_by_name: savedReport.approved_by_name || null
                              }
                          };
                      }
                      return test;
                  })
              }));
          }
      } else {
          toast.error("Failed to create report.");
      }
  } catch(error) {
      console.error("Submit error:", error);
      toast.error("Something went wrong during submission.");
  }
};


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };


    const handleBoldToggle = (paramIndex, testIndex) => {
      setFormData(prev => {
        const updatedL11 = prev.l11.map((test, idx) => {
          if (idx !== testIndex) return test;
          const updatedParams = test.params.map((param, pIdx) => {
            if (pIdx !== paramIndex) return param;
            return { ...param, is_bold: !param.is_bold };
          });
          return { ...test, params: updatedParams };
        });
        return { ...prev, l11: updatedL11 };
      });
    };

    const handleChange1 = (e, paramIndex, testIndex) => {
      const { value } = e.target;
      
      setFormData(prev => {
        const updatedL11 = prev.l11.map((test, idx) => {
          if (idx !== testIndex) return test;
          
          const updatedParams = test.params.map((param, pIdx) => {
            if (pIdx !== paramIndex) return param;
            return { ...param, result: value };
          });
          
          return { ...test, params: updatedParams };
        });
        
        return { ...prev, l11: updatedL11 };
      });
    };

    const handleSaveNext = (index) => {
        toast.success("Saved successfully");
        if (index < formData.l11.length - 1) {
            setActiveIndex(index + 1);
        }
    };

    const handleSearch = () => {
      if (!ldata) {
        toast.error("User not initialized.");
        return;
      }
    
      const fromY = parseToYMD(formData.from);
      const toY = parseToYMD(formData.to);
      if (!fromY || !toY) {
        toast.info("Please select From and To dates, then click Search.");
        return;
      }
    
      setPatientsLoading(true);
      setPatientPage(0);
      // call getTests with parsed YYYY-MM-DD strings
      getTests(ldata.user_id, fromY, toY, false);
    
      // show results area
      setShowSearchDropdown(true);
    };
    
    
    
    

    const handleSearchInputChange = (e) => {
      const value = e.target.value;
      setSearchKey(value);
      setPatientPage(0);
    
      if (value.trim() === '') {
        setSelectedUser(null);
        setFormData(prev => ({ ...prev, test_id0: '', l11: [] }));
        setFilteredPatients(todaysPatients && todaysPatients.length ? todaysPatients : (
          [...new Map((formData.l1 || []).map(item => [item.lab_reg_id, item])).values()]
        ));
        setShowSearchDropdown(true);
        return;
      }
    
      setShowSearchDropdown(true);
    
      // ✅ First: filter from already loaded data (instant)
      const sourceList = [...new Map((formData.l1 || []).map(item => [item.lab_reg_id, item])).values()];
      const localFiltered = sourceList.filter((item) =>
        (item.lab_reg_name || '').toLowerCase().includes(value.toLowerCase()) ||
        ((item.lab_reg_uhid || '').toLowerCase().includes(value.toLowerCase()))
      );
      setFilteredPatients(localFiltered);
    
      // ✅ NEW: Also search backend (across ALL dates) with debounce
      clearTimeout(window._searchDebounce);
      window._searchDebounce = setTimeout(() => {
        searchBackend(value);
      }, 400);
    };
    
    
    const handleSearchKeyDown = (e) => {
      if (e.key === 'Backspace') {
        // If there is a selectedUser and the input currently shows that selection,
        // a single backspace should clear the selection and the input.
        if (selectedUser && searchKey) {
          e.preventDefault(); // avoid deleting characters from the label
          // clear UI and selection
          setSearchKey('');
          setSelectedUser(null);
          setFormData(prev => ({ ...prev, test_id0: '', l11: [] }));
          setSelectedTests(new Set());
          setSelectAllTests(false);
          setActiveIndex(null);
          setPatientPage(0);
          setFilteredPatients(todaysPatients && todaysPatients.length ? todaysPatients : uniquePatients);
          setShowSearchDropdown(true);
          
        }
      }
    };
    

    

    const handlePatientSelect = (item) => {
      setSearchKey(`${item.lab_reg_name} (${item.lab_reg_uhid})`);
      setShowSearchDropdown(false);
    
      // ✅ Get role ID
      const roleId = String(ldata?.role_id || ldata?.user_role_id || '');
    
      // ✅ Only show sample collection alert for Pathologist (role_id = 3) and others, NOT for Radiologist (role_id = 11)
      const status = (item.lab_reg_status || '').toString().toLowerCase();
      const isSamplePending = status === 'pending' || status === 'sample not collected' || status === 'not collected';
      
      if (isSamplePending && roleId !== '11') {
        Swal.fire({
          icon: 'warning',
          title: 'Sample not collected',
          text: 'This patient\'s sample is not yet collected. You cannot create or edit report until the sample is collected.',
          confirmButtonText: 'OK'
        });
        setSelectedUser(item);
        setFormData(prev => ({ ...prev, test_id0: '', l11: [] }));
        return;
      }
    
      fetchedParamIdsRef.current.clear();
    
      let testsForPatient = formData.l1
        .filter(i => i.lab_item_parent === item.lab_item_parent)
        .map(test => {
          const hasLoadedResults = Array.isArray(test.params) && 
            test.params.length > 0 && 
            test.params.some(p => p.result && String(p.result).trim() !== '');
    
          return {
            ...test,
            params: hasLoadedResults ? test.params : (test.params || []),
            impression: test.impression || '',
            notes: test.notes || '',
            interpretation: (test.interpretation && String(test.interpretation).trim())
              ? test.interpretation
              : (test.params && test.params[0] && (test.params[0].test_interpratation || test.params[0].test_interpretation) 
                  ? (test.params[0].test_interpratation || test.params[0].test_interpretation) 
                  : ''),
            report_info: test.report_info || {
              test_report_id: null,
              is_approved: "0",
              approved_by: null,
              approved_by_name: null,
              approval_datetime: null
            }
          };
        });
    
      // ✅ DEBUG: Log before filtering
      console.log("Role ID:", roleId);
      console.log("All tests BEFORE filtering:", testsForPatient.map(t => ({
        lab_item_id: t.lab_item_id,
        name: t.lab_item_test_name,
        test_cat: t.test_cat,
        params_test_cat: t.params?.[0]?.test_cat,
        isRadiology: isRadiologyTest(t)
      })));
    
      // ✅ FILTER TESTS BASED ON ROLE
      testsForPatient = filterTestsByRole(testsForPatient, roleId);
    
      // ✅ DEBUG: Log after filtering
      console.log("Tests AFTER filtering:", testsForPatient.map(t => ({
        lab_item_id: t.lab_item_id,
        name: t.lab_item_test_name,
        test_cat: t.test_cat,
        isRadiology: isRadiologyTest(t)
      })));
    
      setFormData(prev => ({
        ...prev,
        test_id0: item.lab_item_parent,
        l11: testsForPatient
      }));
    
      setSelectedUser(item);
    };

    const get_param_val = (tmp) => {
  if (!tmp) return "";

  const type = (tmp.test_param_type || "").trim();

  // Numeric -> show "from - to" but only if either exists
  if (type === "Numeric") {
    const from = tmp.test_param_from_range ?? "";
    const to = tmp.test_param_to_range ?? "";
    if (from === "" && to === "") return "";
    // show "from - to", but handle single-side ranges gracefully
    if (from !== "" && to !== "") return `${from} - ${to}`;
    if (from !== "") return `${from}`;
    return `${to}`;
  }

  // Boolean -> prefer server-provided labels, otherwise default to Yes / No
  if (type === "Boolean") {
    return tmp.test_param_from_range || "Yes / No";
  }

  // Editor / Text / other types -> show whatever is present, otherwise empty
  return tmp.test_param_from_range || "";
};


    const get_param_val1 = (tmp) => {
        if (tmp.test_param_type === "Numeric") return 1;
        if (tmp.test_param_type === "Boolean") return 2;
        return 3;
    };

    const uniquePatients = [...new Map(formData.l1.map(item => [item['lab_reg_id'], item])).values()];

    useEffect(() => {
      if (!formData.test_id0) {
        setSelectedUser(null);
        setFormData(prev => ({ ...prev, l11: [] }));
        return;
      }
      
      let tmp = formData.l1.filter(item => item.lab_item_parent === formData.test_id0);
      
      // ✅ FILTER TESTS BASED ON ROLE
      const roleId = ldata?.role_id || ldata?.user_role_id || '';
      tmp = filterTestsByRole(tmp, roleId);
      
      setSelectedUser(tmp[0] || null);
      setFormData(prev => ({ ...prev, l11: tmp }));
    }, [formData.test_id0, formData.l1, ldata?.role_id]);

    useEffect(() => {
  fetchedParamIdsRef.current.clear();
}, [selectedUser?.lab_reg_id]);
    // Safe effect to ensure missing params are fetched
// Safe effect to ensure missing params are fetched
useEffect(() => {
  if (!Array.isArray(formData.l11) || formData.l11.length === 0) return;

  formData.l11.forEach(test => {
    // Use lab_item_test_id to fetch param definitions
    const testId = test.lab_item_test_id ?? test.id;
    // Use lab_item_id as unique identifier
    const labItemId = test.lab_item_id;
    
    if (!testId || !labItemId) return;
    
    // Only fetch if params missing/empty AND no results loaded from DB
    const hasParams = Array.isArray(test.params) && test.params.length > 0;
    const hasResults = hasParams && test.params.some(p => p.result && String(p.result).trim() !== '');
    
    if (!hasParams && !hasResults) {
      fetchTestParams(testId, labItemId);
    }
  });
}, [formData.l11.length, selectedUser?.lab_reg_id]); // ✅ Changed dependencies

    useEffect(() => {
      if (activeIndex === null) return;
      if (!Array.isArray(formData.l11) || !formData.l11[activeIndex]) return;
    
      const activeTest = formData.l11[activeIndex];
      if (!Array.isArray(activeTest.params) || activeTest.params.length === 0) {
        // fetch but do not rely on index being unchanged — fetchTestParams checks again before updating
        fetchTestParams(activeTest.lab_item_test_id, activeIndex);
      }
    }, [activeIndex, formData.l11]);
    
    useEffect(() => {
      if (!formData.test_id0) {
        setSelectedUser(null);
        setFormData(prev => ({ ...prev, l11: [] }));
        return;
      }
    
      let tmp = formData.l1.filter(item => item.lab_item_parent === formData.test_id0);
      
      // ✅ FILTER TESTS BASED ON ROLE
      const roleId = ldata?.role_id || ldata?.user_role_id || '';
      tmp = filterTestsByRole(tmp, roleId);
      
      setSelectedUser(tmp[0] || null);
      setFormData(prev => ({ ...prev, l11: tmp }));
    }, []);


    const handleBlur = () => {
        setTimeout(() => {
            if (
                document.activeElement !== inputRef.current &&
                !dropdownRef.current?.contains(document.activeElement)
            ) {
                setShowSearchDropdown(false);
            }
        }, 100);
    };


    const isAllResultsFilled = (params) => {
        if (!params) return false;
        return params.every(param => param.result && param.result.toString().trim() !== '');
    };
    
    // =================================================================================
    // NEW PDF GENERATION LOGIC
    // =================================================================================

    // Function to check if a value is outside the normal range
    const isAbnormal = (result, normalRange, gender) => {
        if (!result || !normalRange) return false;
        
        const numResult = parseFloat(result);
        if (isNaN(numResult)) return false;

        // Simple range like "4000-11000"
        let rangeStr = normalRange;

        // Handle gender-specific ranges like "M:12-18 F:11.5-15.5"
        if (normalRange.includes("M:") && gender) {
            const genderChar = gender.charAt(0).toUpperCase();
            const ranges = normalRange.split(' ');
            const relevantRange = ranges.find(r => r.startsWith(genderChar + ":"));
            if (relevantRange) {
                rangeStr = relevantRange.substring(2);
            }
        }

        const rangeParts = rangeStr.match(/(\d+\.?\d*)-(\d+\.?\d*)/);
        if (rangeParts && rangeParts.length === 3) {
            const lower = parseFloat(rangeParts[1]);
            const upper = parseFloat(rangeParts[2]);
            return numResult < lower || numResult > upper;
        }

        return false;
    };
    
       const initData2 = async () => {
            const storedData = sessionStorage.getItem("ldata");
 const storedDataF = JSON.parse(sessionStorage.getItem("ldata") || "{}");
// console.log("session data :", storedDataF);

setName(
  [storedDataF?.fname, storedDataF?.lname].filter(Boolean).join(" ")
);
            if (storedData) {
                const parsed = JSON.parse(storedData);
                const fd = new FormData();
                fd.append('cat_type', "department");
                fd.append('page_no', "none");
                fd.append('search_key', "");
                fd.append('par_by', 1 + "");
    
                try {
                    const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd);
                    if (response.data.status && response.data.records) {
                        setFormData(prev => ({
                            ...prev,
                            departs: response.data.records
                        }));

                    }
                } catch (error) {
                    console.error(error);
                }
            }
        };

        // console.log("department : " + JSON.stringify(formData.departs))

        const fetchSignConfigData = async () => {
          if (!Array.isArray(formData.departs) || formData.departs.length === 0) return;
          try {
            const allSignData = {};
            const allPreviews = {};
        
            // sequential requests (safer than Promise.all for many items)
            for (const dep of formData.departs) {
              try {
                const fd = new FormData();
                fd.append('sign_department', String(dep.cat_id));
                const res = await axios.post(AppConst.BASE_URL + AppConst.getSignByDepartUrl, fd);
                if (res.data && res.data.status && res.data.sign_dt) {
                  allSignData[dep.cat_id] = res.data.sign_dt;
                  allPreviews[dep.cat_id] = {
                    tech: res.data.sign_dt.sign_tech_sign ? AppConst.BASE_URL + res.data.sign_dt.sign_tech_sign : null,
                    doc: res.data.sign_dt.sign_doc_sign ? AppConst.BASE_URL + res.data.sign_dt.sign_doc_sign : null
                  };
                }
                // small pause to avoid overwhelming server/browser (optional)
                await new Promise(r => setTimeout(r, 50));
              } catch (innerErr) {
                console.warn('fetchSignConfigData: failed for dep', dep.cat_id, innerErr);
                // continue on error
              }
            }
        
            setFormData(prev => ({ ...prev, selItem: allSignData }));
          } catch (err) {
            console.error('fetchSignConfigData: unexpected error', err);
          }
        };
        


// console.log("formData:", JSON.stringify(formData.selItem));
     
const fetchConfigData = async () => {
  try {
    const res = await axios.post(`${AppConst.BASE_URL + AppConst.getconfig}?config_type=lab`);
    if (res.data && res.data.status) {
      setImage(res.data.header_logo || '');
      setWatermarkImage(res.data.logo || '');
      setFooterImage(res.data.footer_logo || '');
    } else {
      console.warn('fetchConfigData: config endpoint returned ok but status false', res.data);
    }
  } catch (err) {
    console.error("Error fetching config:", err);
    // show user-friendly message once (don't spam on repeated effects)
    toast.warn("Config images unavailable — continuing without header/footer.");
  }
};

    
    // fetch config once on mount
useEffect(() => {
  fetchConfigData();
  // initData2() is already called in another effect; avoid duplicates
}, []);

// fetch sign config only when departments list is populated
useEffect(() => {
  if (!formData.departs || formData.departs.length === 0) return;
  // call sign fetcher (see throttled version below)
  fetchSignConfigData();
}, [formData.departs]);

     
    
const _imageCache = {}; // module-level cache

const imageUrlToBase64 = async (url) => {
  if (!url) return null;
  if (_imageCache[url]) return _imageCache[url]; // return cached

  try {
    // optional: ensure URL is absolute and same origin if possible, or proxy via server
    const response = await fetch(url, { cache: 'no-cache', mode: 'cors' });
    if (!response.ok) {
      console.error(`image fetch failed: ${url}`, response.status);
      return null;
    }
    const blob = await response.blob();
    if (!blob.type.startsWith('image/')) return null;
    const result = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
    _imageCache[url] = result;
    return result;
  } catch (err) {
    console.error("imageUrlToBase64 error (likely CORS or network):", url, err);
    return null;
  }
};




    const formatCellValue = (htmlString) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;

    // Agar table hai to manually cell text banao
    const table = tempDiv.querySelector("table");
    if (table) {
        
        let rows = [];
        for (const tr of table.querySelectorAll("tr")) {
            let cells = [];
            for (const td of tr.querySelectorAll("td")) {
                cells.push(td.innerText.trim());
            }
            rows.push(cells.join(" | ")); // table ke cells ko " | " se separate
        }
        return rows.join("\n"); // rows ko newline se separate
    }

    // Agar simple HTML hai to text return karo
    return tempDiv.innerText.trim();
};

const addHeaderAndFooter = async (doc, printTypeOpt = 'with') => {
  const pageWidth = typeof doc.internal.pageSize.getWidth === 'function' ? doc.internal.pageSize.getWidth() : doc.internal.pageSize.width;
  const pageHeight = typeof doc.internal.pageSize.getHeight === 'function' ? doc.internal.pageSize.getHeight() : doc.internal.pageSize.height;

  // Watermark: guard GState usage
  try {
    const watermarkBase64 = await imageUrlToBase64(watermarkImage);
    if (watermarkBase64 && typeof doc.setGState === 'function') {
      doc.setGState(new doc.GState ? new doc.GState({ opacity: 0.08 }) : { opacity: 0.08 });
      doc.addImage(watermarkBase64, 'PNG', (pageWidth - 120) / 2, (pageHeight - 120) / 2, 120, 120);
      if (typeof doc.setGState === 'function') doc.setGState(new doc.GState ? new doc.GState({ opacity: 1 }) : { opacity: 1 });
    }
  } catch (e) {
    console.warn('watermark add failed', e);
  }

  // ✅ ONLY add header/footer images if printType is "with"
  if (printTypeOpt === 'with') {
    try { 
      const headerImageBase64 = await imageUrlToBase64(image); 
      if (headerImageBase64) doc.addImage(headerImageBase64, 0, 0, pageWidth, 30); 
    } catch(e) { console.warn('header add failed', e); }
    
    try { 
      const footerImageBase64 = await imageUrlToBase64(footerImage); 
      if (footerImageBase64) doc.addImage(footerImageBase64, 0, pageHeight - 13, pageWidth, 13); 
    } catch(e) { console.warn('footer add failed', e); }
  }
};


const formatDateTime12h = (dateTimeStr) => {
  if (!dateTimeStr) return "";
  try {
    const d = new Date(dateTimeStr);
    if (isNaN(d.getTime())) return dateTimeStr;
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    let hours = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const seconds = String(d.getSeconds()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${day}-${month}-${year} ${String(hours).padStart(2,"0")}:${minutes}:${seconds} ${ampm}`;
  } catch (e) {
    console.warn("formatDateTime12h failed:", e);
    return dateTimeStr;
  }
};
// Helper: format Date -> YYYY-MM-DD for <input type="date">
const formatDateForInput = (d = new Date()) => {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// Robust parser: accepts "DD/MM/YYYY", "DD-MM-YYYY", "YYYY-MM-DD", timestamps, Date objects.
// Returns YYYY-MM-DD or '' if cannot parse.
const parseToYMD = (val) => {
  if (!val && val !== 0) return '';
  if (val instanceof Date && !isNaN(val.getTime())) return formatDateForInput(val);

  const s = String(val).trim();
  // YYYY-MM-DD or YYYY/MM/DD
  let m = s.match(/^(\d{4})[\/-](\d{2})[\/-](\d{2})/);
  if (m) return `${m[1]}-${m[2]}-${m[3]}`;

  // DD/MM/YYYY or DD-MM-YYYY -> convert to YYYY-MM-DD
  m = s.match(/^(\d{2})[\/-](\d{2})[\/-](\d{4})/);
  if (m) return `${m[3]}-${m[2]}-${m[1]}`;

  // Last resort: Date parse
  const dt = new Date(s);
  if (!isNaN(dt.getTime())) return formatDateForInput(dt);

  return '';
};

// --- Helper: safe rect to avoid invalid-args exception
const safeRect = (doc, xRaw, yRaw, wRaw, hRaw) => {
  const x = Number(xRaw), y = Number(yRaw), w = Number(wRaw), h = Number(hRaw);
  const ok = [x, y, w, h].every(v => Number.isFinite(v));
  if (ok) {
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.2);
    doc.rect(x, y, w, h);
  } else {
    console.warn("safeRect: skipping rect due to invalid args", { xRaw, yRaw, wRaw, hRaw, parsed: { x, y, w, h } });
  }
};

// --- Drop-in: robust async printPatientDetails (use await when calling) ---
const printPatientDetails = async (doc, patient = {}, startY = 40) => {
  try {
    // Basic validations
    if (!doc || !doc.internal) {
      console.error("printPatientDetails: invalid doc", doc);
      return Number(startY) || 12;
    }
    // Ensure startY numeric
    startY = Number(startY);
    if (!isFinite(startY)) startY = 40;

    // Robust pageWidth detection for different jsPDF versions
    let pageWidthRaw;
    try {
      pageWidthRaw = typeof doc.internal.pageSize.getWidth === 'function'
        ? doc.internal.pageSize.getWidth()
        : doc.internal.pageSize.width;
    } catch (e) {
      pageWidthRaw = doc.internal.pageSize && doc.internal.pageSize.width;
    }
    const pageWidth = Number(pageWidthRaw);
    const PAGE_WIDTH = isFinite(pageWidth) ? pageWidth : 210; // fallback

    // Box geometry (numbers)
    const boxLeft = 10;
    const boxTop = startY - 2; // small margin
    const boxWidth = PAGE_WIDTH - boxLeft * 2;
    const boxHeight = 26; // adjust if you need more space

    // Draw outer box safely
    safeRect(doc, boxLeft, boxTop, boxWidth, boxHeight);

    // Optionally draw header logo on left (if imageUrlToBase64 exists and image state holds url)
    try {
      // if (typeof imageUrlToBase64 === "function" && image) {
      //   const logoBase64 = await imageUrlToBase64(image);
      //   if (logoBase64) {
      //     const logoH = Math.min(34, boxHeight - 8);
      //     const logoW = logoH; // square logo; change if needed
      //     const logoX = boxLeft + 6;
      //     const logoY = boxTop + 6;
      //     if ([logoX, logoY, logoW, logoH].every(v => isFinite(v))) {
      //       doc.addImage(logoBase64, "PNG", logoX, logoY, logoW, logoH);
      //     }
      //   }
      // }
    } catch (e) {
      console.warn("printPatientDetails: logo draw failed (CORS/URL)", e);
    }

    // QR: vertically centered inside the box and at right
    // const qrSize = 20;
    // const qrX = boxLeft + boxWidth - qrSize - 3;
    // const qrY = boxTop + (boxHeight - qrSize) / 10;
    // try {
    //   const qrText = `${patient.lab_reg_uhid || ''} | ${patient.lab_reg_name || ''}`;
    //   const qrDataUrl = await QRCode.toDataURL(qrText, { width: 200 });
    //   if (qrDataUrl && [qrX, qrY, qrSize].every(v => isFinite(v))) {
    //     doc.addImage(qrDataUrl, "PNG", qrX, qrY, qrSize, qrSize);
    //   } else {
    //     console.warn("printPatientDetails: QR coords invalid", { qrX, qrY, qrSize });
    //   }
    // } catch (e) {
    //   console.warn("printPatientDetails: QR generation failed", e);
    // }

    // In printPatientDetails function, update the QR code section:

// QR: vertically centered inside the box and at right
const qrSize = 18;
const qrX = boxLeft + boxWidth - qrSize - 3;
const qrY = boxTop + (boxHeight - qrSize) / 10;
try {
  // ✅ UPDATED: QR code contains download URL (excludes radiology automatically)
  const baseUrl = window.location.origin; // Your domain
  const qrUrl = `${baseUrl}/qr-report/${patient.lab_reg_id}`;
  
  // Generate QR code with the URL
  const qrDataUrl = await QRCode.toDataURL(qrUrl, { 
    width: 200,
    margin: 1,
    errorCorrectionLevel: 'M'
  });
  
  if (qrDataUrl && [qrX, qrY, qrSize].every(v => isFinite(v))) {
    doc.addImage(qrDataUrl, "PNG", qrX, qrY, qrSize, qrSize);
  }
} catch (e) {
  console.warn("QR generation failed", e);
}

    // Prepare formatted values
    const dateParts = String(patient.lab_reg_date || "").split("-");
    const formattedDate = (dateParts.length >= 3) ? `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}` : (patient.lab_reg_date || "");
    const sampleCollectedOn = patient.lab_reg_sample_datetime 
    ? formatDateTime12h(patient.lab_reg_sample_datetime) 
    : 'N/A';
    
    const reportedOn = formatDateTime12h(formData?.test_report_datetime || new Date().toISOString());
   
    

    // Text columns (left and right labels/values)
    const leftColLabel = boxLeft + 4;
    const leftColValue = leftColLabel + 36;
    const rightColLabel = boxLeft + Math.round(boxWidth * 0.5) + 4;
    const rightColValue = rightColLabel + 36;

    // Start writing inside box — choose start row
    let yPos = boxTop + 5;
    doc.setFontSize(10);

    doc.setFont('helvetica', 'bold'); doc.text("UHID", leftColLabel, yPos);
    doc.setFont('helvetica', 'normal'); doc.text(`: ${patient.lab_reg_uhid || ''}`, leftColValue, yPos);
    doc.setFont('helvetica', 'bold'); doc.text("Patient ID", rightColLabel, yPos);
    doc.setFont('helvetica', 'normal'); doc.text(`: 00${patient.lab_reg_id || ''}`, rightColValue, yPos);
    yPos += 4;

    doc.setFont('helvetica', 'bold'); doc.text("Patient Name", leftColLabel, yPos);
const titlePrefix = patient.lab_reg_name_title ? String(patient.lab_reg_name_title).trim() + ' ' : '';
doc.setFont('helvetica', 'normal');
doc.text(`: ${titlePrefix}${patient.lab_reg_name || ''}`, leftColValue, yPos);

    doc.setFont('helvetica', 'bold'); doc.text("Registered On", rightColLabel, yPos);
    doc.setFont('helvetica', 'normal'); doc.text(`: ${formattedDate}`, rightColValue, yPos);
    yPos += 4;

    doc.setFont('helvetica', 'bold');
    doc.text("Age / Gender", leftColLabel, yPos);
    doc.setFont('helvetica', 'normal');
    doc.text(`: ${getAgeDisplay(patient)} / ${patient.lab_reg_gender || ''}`, leftColValue, yPos);
    
    doc.setFont('helvetica', 'bold'); doc.text("Collected At", rightColLabel, yPos);
    doc.setFont('helvetica', 'normal'); doc.text(`: ${patient.lab_collected_at || ''}`, rightColValue, yPos);
    yPos += 4;

    doc.setFont('helvetica', 'bold'); doc.text("Referred By", leftColLabel, yPos);
    doc.setFont('helvetica', 'normal'); doc.text(`: ${patient.lab_reg_referral || 'N/A'}`, leftColValue, yPos);
    doc.setFont('helvetica', 'bold'); doc.text("Sample Collected By", rightColLabel, yPos);
    doc.setFont('helvetica', 'normal'); doc.text(`: ${Name || ''}`, rightColValue, yPos);
    yPos += 4;

    // ✅ Reported On + Sample Collection datetime

  // ✅ Sample Collection on LEFT, Reported On on RIGHT
  doc.setFont('helvetica', 'bold'); doc.text("Sample Collection", leftColLabel, yPos);
  doc.setFont('helvetica', 'normal'); doc.text(`: ${sampleCollectedOn}`, leftColValue, yPos);
  doc.setFont('helvetica', 'bold'); doc.text("Reported On", rightColLabel, yPos);
  doc.setFont('helvetica', 'normal'); doc.text(`: ${reportedOn}`, rightColValue, yPos);
  yPos += 4;
    // Return the Y position after the box so caller can continue
    return boxTop + boxHeight + 10;
  } catch (err) {
    console.error("printPatientDetails: unexpected error", err);
    return Number(startY) + 9;
  }
};


async function addSignatures(doc, signData) {
    const finalY = doc.internal.pageSize.getHeight() - 48;

    console.log("sign " +JSON.stringify(signData))

    if (!signData) return;

    // ==== Left: Lab Technician ====
    if (signData.sign_tech_sign ) {
        if (signData.sign_tech_sign) {
            const techSignBase64 = await imageUrlToBase64(AppConst.BASE_URL + signData.sign_tech_sign);
            if (techSignBase64) {
                doc.addImage(techSignBase64, 'PNG', 14, finalY, 30, 15);
            }
        }
        if (signData.sign_tech_name) {
            const techName = signData.sign_tech_name || '';
            const techId = signData?.sign_tech_id ? ` (${signData.sign_tech_id})` : '';
            doc.setFontSize(9).setFont('helvetica', 'normal').text(`${techName}${techId}`, 14, finalY + 20);
            doc.setFontSize(9).setFont('helvetica', 'bold').text("Lab Technician", 14, finalY + 24);
        }
    }

    // ==== Right: Authorized Doctor ====
    // if (signData.sign_doc_sign || signData.sign_doc_name) {
    //     if (signData.sign_doc_sign) {
    //         const docSignBase64 = await imageUrlToBase64(AppConst.BASE_URL + signData.sign_doc_sign);
    //         if (docSignBase64) {
    //             doc.addImage(docSignBase64, 'PNG', 166, finalY, 30, 15);
    //         }
    //     }
    //     if (signData.sign_doc_name) {
    //         const docName = signData.sign_doc_name || '';
    //         const docId = signData?.sign_doc_id ? ` (${signData.sign_doc_id})` : '';
    //         doc.setFontSize(11).setFont('helvetica', 'bold').text(`${docName}${docId}`, 196, finalY + 20, { align: 'right' });

    //         // ✅ Pathologist vs Consultant text
    //         const designation = (signData.sign_department === '60') ? "Consultant" : "Consultant Pathologist";
    //         doc.setFontSize(9).setFont('helvetica', 'bold').text(designation, 196, finalY + 24, { align: 'right' });
    //     }
    // }

    // ==== Right: Authorized Doctor ====
if (signData.sign_doc_sign || signData.sign_doc_name) {

  if (signData.sign_doc_sign) {
      const docSignBase64 = await imageUrlToBase64(
          AppConst.BASE_URL + signData.sign_doc_sign
      );
      if (docSignBase64) {
          doc.addImage(docSignBase64, 'PNG', 166, finalY, 30, 15);
      }
  }

  if (signData.sign_doc_name) {
      const docName = signData.sign_doc_name || '';
      const docId = signData?.sign_doc_id
          ? ` (${signData.sign_doc_id})`
          : '';

      doc.setFontSize(11)
         .setFont('helvetica', 'bold')
         .text(`${docName}${docId}`, 196, finalY + 20, { align: 'right' });

      // ✅ DB-driven designation
      let designation = '';
      if (signData.sign_doc_spec && signData.sign_doc_quali) {
          designation = `${signData.sign_doc_spec}`;
      } else if (signData.sign_doc_spec) {
          designation = signData.sign_doc_spec;
      } else if (signData.sign_doc_quali) {
          designation = signData.sign_doc_quali;
      } else {
          designation = 'Consultant';
      }

      doc.setFontSize(9)
         .setFont('helvetica', 'bold')
         .text(designation, 196, finalY + 24, { align: 'right' });
  }
}

}




const drawHtmlContent = async (doc, htmlString, initialX, initialY, options) => {
    const { maxWidth, addNewPage, pageHeight, pageBuffer } = options;
    let x = initialX;
    let y = initialY;

    // Use a style stack to handle nested formatting (e.g., <b><i>text</i></b>)
    const styleStack = [{ font: 'helvetica', style: 'normal', size: 9 }];

    const applyStyle = () => {
        const currentStyle = styleStack[styleStack.length - 1];
        doc.setFontSize(currentStyle.size);
        doc.setFont(currentStyle.font, currentStyle.style);
    };
    
    // This recursive function will parse the DOM nodes
    const parseNodes = async (nodes) => {
        for (const node of nodes) {
            if (y > pageHeight - pageBuffer) {
                y = await addNewPage();
            }

            if (node.nodeType === 3) { // Text node
                const text = node.nodeValue.trim();
                if (!text) continue;

                const words = text.split(/\s+/);
                for (const word of words) {
                    const wordWidth = doc.getTextWidth(word + ' ');
                    if (x + wordWidth > initialX + maxWidth) {
                        x = initialX;
                        y += 5; // Line height
                         if (y > pageHeight - pageBuffer) {
                            y = await addNewPage();
                        }
                    }
                    applyStyle();
                    doc.text(word, x, y);
                    x += wordWidth;
                }
                 // Add a space after a text segment if it's not the end of a block
                if (x > initialX) {
                     x += doc.getTextWidth(' ');
                }


            } else if (node.nodeType === 1) { // Element node
                const tagName = node.tagName.toUpperCase();
                let newStyle = { ...styleStack[styleStack.length - 1] };
                let isBlockElement = false;

                switch (tagName) {
                    case 'STRONG':
                    case 'B':
                        newStyle.style = 'bold';
                        break;
                    case 'EM':
                    case 'I':
                        newStyle.style = 'italic';
                        break;
                    case 'P':
                        if (x > initialX) { // Newline before starting a paragraph
                           y += 8;
                           x = initialX;
                        }
                        isBlockElement = true;
                        break;
                    case 'LI':
                        if (x > initialX) { // Newline before list item
                           y += 6;
                        }
                         x = initialX;
                        applyStyle();
                        doc.text('• ', x, y);
                        x += 5;
                        isBlockElement = true;
                        break;
                    case 'UL':
                    case 'OL':
                         if (x > initialX) {
                           y += 8;
                           x = initialX;
                         }
                         isBlockElement = true;
                         break;
                }

                styleStack.push(newStyle);
                await parseNodes(node.childNodes);
                styleStack.pop();
                
                if (isBlockElement) {
                     x = initialX; // Reset X for next element
                     y += 5; // Add some space after block elements
                }
            }
        }
    };
    
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;

    await parseNodes(tempDiv.childNodes);

    return y; // Return the final y position
};



// helper: returns formatted age text or 'N/A'
// returns formatted age with plural 's' when >1, or 'N/A' if all zero
const getAgeDisplay = (p) => {
  if (!p) return 'N/A';
  const y = Number(p.lab_reg_age_year || 0);
  const m = Number(p.lab_reg_age_month || 0);
  const d = Number(p.lab_reg_age_day || 0);

  if (y === 0 && m === 0 && d === 0) return 'N/A';

  const parts = [];
  if (y > 0) parts.push(`${y}Y${y > 1 ? 's' : ''}`);
  if (m > 0) parts.push(`${m}M${m > 1 ? 's' : ''}`);
  if (d > 0) parts.push(`${d}D${d > 1 ? 's' : ''}`);

  return parts.join(' ');
};




const generatePdfForTests = async (testsToPrint, printTypeOpt = 'with') => {
  console.log("generated pdf :" + JSON.stringify(testsToPrint));
  const doc = new jsPDF();
  const patient = selectedUser;
  let hasRadiology = false;

  try {
    const fontBase64 = await loadFontAsBase64("/DejaVuSans.ttf");
    doc.addFileToVFS("DejaVuSans.ttf", fontBase64);
    doc.addFont("DejaVuSans.ttf", "DejaVu", "normal");
    doc.setFont("DejaVu");
  } catch (error) {
    console.error("Font loading failed:", error);
    toast.error("Font loading failed. Arrows may not display correctly.");
  }

  if (!patient) {
    toast.error("No patient selected!");
    return;
  }

  const pageHeight = doc.internal.pageSize.getHeight();
  const pageWidth = doc.internal.pageSize.getWidth();

  const SIGNATURE_AREA_HEIGHT = 32;
  // ✅ TOP_SAFE_Y is the Y position where content can start on a NEW page
  //    after the header image (30pt) + patient details box (~26pt) + padding
  //    With header: header(30) + patient box top at 38 + box height 26 = ends ~64, +2 padding = 66
  //    Without header: patient box top at 18 + box height 26 = ends ~44, +2 padding = 46
  const TOP_SAFE_Y = printTypeOpt === 'with' ? 66 : 66;
  const SAFE_BOTTOM = pageHeight - SIGNATURE_AREA_HEIGHT;

  let currentPageNumber = 1;
  let lastPrintedDeptOnCurrentPage = null;

  const addNewPage = async () => {
    doc.addPage();
    currentPageNumber++;
    lastPrintedDeptOnCurrentPage = null;
    await addHeaderAndFooter(doc, printTypeOpt);

    const startY = printTypeOpt === 'with' ? 40 : 40;
    return await printPatientDetails(doc, patient, startY);
  };

  const hasSpace = (neededHeight) => {
    return yPos + neededHeight <= SAFE_BOTTOM;
  };

  const printDepartmentHeader = (deptName) => {
    yPos += 4;
    doc.setFillColor(180, 220, 250);
    doc.rect(10, yPos - 5, 190, 8, 'FD');
    doc.setFontSize(12).setFont('helvetica', 'bold').setTextColor(0, 0, 0);
    doc.text(deptName, 105, yPos, { align: 'center' });
    yPos += 8;
    lastPrintedDeptOnCurrentPage = deptName;
  };

  // --- First Page Setup ---
  await addHeaderAndFooter(doc, printTypeOpt);
  let yPos = await printPatientDetails(doc, patient, printTypeOpt === 'with' ? 40 : 40);

  // ✅ Better row height estimator — accounts for multi-line content in normal range column
  const estimateRowHeight = (row) => {
    if (!row || !Array.isArray(row)) return 6;
    // Main test name row (single colSpan cell)
    if (row.length === 1 && row[0]?.colSpan) return 8;
    // Normal range is usually the longest text — column index 3
    const rangeCell = row[3];
    const rangeText = typeof rangeCell === 'string' ? rangeCell : (rangeCell?.content || '');
    // ~32 chars fit in the 40pt-wide range column at fontSize 9
    const lines = Math.max(1, Math.ceil(String(rangeText).length / 30));
    return Math.max(6, lines * 4 + 2);
  };

  const drawMainTable = async (rows, needsHead, currentDept, testName, reserveAfter = 0, pendingDept = null) => {
    if (rows.length <= 1) return;

    const deptHeaderHt = pendingDept ? 12 : 0;
    // ✅ More accurate height estimate using row-by-row analysis
    const rowsHeight = rows.reduce((sum, r) => sum + estimateRowHeight(r), 0);
    const tableHeightEstimate = deptHeaderHt + rowsHeight + (needsHead ? 10 : 0) + reserveAfter;

    if (!hasSpace(tableHeightEstimate)) {
      yPos = await addNewPage();
      const deptToPrint = pendingDept || currentDept;
      if (deptToPrint) {
        printDepartmentHeader(deptToPrint);
      }
      needsHead = true;
    } else if (pendingDept) {
      printDepartmentHeader(pendingDept);
    }

    await autoTable(doc, {
      startY: yPos,
      head: needsHead ? [["TEST NAME", "RESULT", "UNITS", "NORMAL RANGES", "METHOD"]] : null,
      body: rows,
      theme: 'plain',
      headStyles: { fillColor: [180, 220, 250], textColor: 0, fontStyle: 'bold', halign: 'center' },
      styles: { fontSize: 9, cellPadding: 0.8, valign: 'middle', minCellHeight: 3 },
      columnStyles: {
        0: { cellWidth: 48 },
        1: { cellWidth: 38, halign: 'center' },
        2: { cellWidth: 22, halign: 'center' },
        3: { cellWidth: 40, halign: 'center' },
        4: { cellWidth: 43, halign: 'center' }
      },
      // ✅ pageBreak: 'auto' is default — autoTable will break naturally when needed
      // ✅ Only set top margin so that NEW pages created by autoTable respect header area
      margin: { left: 10, right: 10, top: TOP_SAFE_Y, bottom: SIGNATURE_AREA_HEIGHT + reserveAfter },
      didDrawPage: (data) => {
        if (data.pageNumber > currentPageNumber) {
          // autoTable created a new page itself — add header/footer to it
          currentPageNumber = data.pageNumber;
          lastPrintedDeptOnCurrentPage = null;
          addHeaderAndFooter(doc, printTypeOpt);
          printPatientDetails(doc, patient, printTypeOpt === 'with' ? 40 : 40);
        }
      },
      didDrawCell: (data) => {
        if (data.section === 'body' && data.row.index === 0 && data.cell.raw && data.cell.raw.isMainTest) {
          doc.setDrawColor(0, 0, 0);
          doc.setLineWidth(0.2);
          const textWidth = doc.getTextWidth(data.cell.text[0]);
          const lineY = data.cell.y + data.cell.height - 1.5;
          doc.line(data.cell.x + 2, lineY, data.cell.x + 2 + textWidth, lineY);
        }
      }
    });

    yPos = (doc.lastAutoTable && doc.lastAutoTable.finalY) ? doc.lastAutoTable.finalY + 1 : yPos + 1;
  };

  const departmentMap = {};
  (formData.departs || []).forEach(d => { departmentMap[d.cat_id] = d.cat_name; });

  const getDeptName = (test) => {
    if (test.params && test.params.length > 0) {
      return departmentMap[test.params[0].test_cat] || "HEMATOLOGY";
    }
    return "HEMATOLOGY";
  };

  const hasAnyPrintableContent = (test) => {
    if (!test.params || test.params.length === 0) return false;
    return test.params.some(param => {
      const rawName = String(param.test_param_name || "").trim();
      const isPdfStarred = /^\*.+\*$/.test(rawName);
      if (param.test_param_type === "Editor") {
        return param.result && String(param.result).trim() !== '';
      }
      if (isPdfStarred) return false;
      return param.result !== undefined && param.result !== null && String(param.result).trim() !== '';
    });
  };

  const sortedTests = [...testsToPrint].sort((a, b) => {
    const deptA = getDeptName(a).toUpperCase();
    const deptB = getDeptName(b).toUpperCase();
    if (deptA < deptB) return -1;
    if (deptA > deptB) return 1;
    return 0;
  });

  for (const test of sortedTests) {

    if (!hasAnyPrintableContent(test)) {
      console.log("Skipping test with no printable content:", test.lab_item_test_name);
      continue;
    }

    let deptName = getDeptName(test);

    if (deptName && deptName.toLowerCase() === "radiology") {
      hasRadiology = true;
    }

    let addTableHead = false;
    let pendingDeptHeader = null;
    if (deptName && deptName !== lastPrintedDeptOnCurrentPage) {
      pendingDeptHeader = deptName;
      addTableHead = true;
    }

    let paramsRows = [];
    const mainTestNameRow = [{
      content: test.lab_item_test_name,
      colSpan: 5,
      styles: { fontStyle: 'bold', textColor: [0, 0, 0], cellPadding: { top: 2, bottom: 2, left: 2 } },
      isMainTest: true
    }];
    paramsRows.push(mainTestNameRow);

    let hasResultInCurrentTable = false;

    for (const param of test.params) {
      const rawParamName = String(param.test_param_name || "");
      const isPdfStarred = /^\*.+\*$/.test(rawParamName.trim());
      const pdfParamName = isPdfStarred ? rawParamName.trim().replace(/^\*(.+)\*$/, '$1') : rawParamName;

      if (param.test_param_type === "Editor") {
        if (hasResultInCurrentTable) {
          await drawMainTable(paramsRows, addTableHead, deptName, test.lab_item_test_name, 0, pendingDeptHeader);
          pendingDeptHeader = null;
          paramsRows = [mainTestNameRow];
          hasResultInCurrentTable = false;
          addTableHead = false;
        }

        if (pendingDeptHeader) {
          if (!hasSpace(20)) {
            yPos = await addNewPage();
          }
          printDepartmentHeader(pendingDeptHeader);
          pendingDeptHeader = null;
        }

        if (!hasSpace(12)) {
          yPos = await addNewPage();
          if (deptName && deptName !== lastPrintedDeptOnCurrentPage) {
            printDepartmentHeader(deptName);
          }
        }
        yPos += 1;

        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.text(pdfParamName, 16, yPos);
        yPos += 4;

        const editorContent = String(param.result || "").trim();

        if (editorContent) {
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = editorContent;
          const tableElement = tempDiv.querySelector("table");

          const htmlContentToRender = (() => {
            if (!tableElement) return tempDiv.innerHTML;
            const cloned = tempDiv.cloneNode(true);
            const figure = cloned.querySelector('figure.table, figure');
            if (figure && figure.querySelector('table')) {
              figure.remove();
            } else {
              const tbl = cloned.querySelector("table");
              if (tbl) tbl.remove();
            }
            return cloned.innerHTML;
          })();

          if (htmlContentToRender && String(htmlContentToRender).trim()) {
            yPos = await drawHtmlContent(doc, htmlContentToRender, 16, yPos, {
              maxWidth: 178,
              addNewPage: async () => {
                const newY = await addNewPage();
                if (deptName && deptName !== lastPrintedDeptOnCurrentPage) {
                  printDepartmentHeader(deptName);
                }
                return newY;
              },
              pageHeight,
              pageBuffer: SIGNATURE_AREA_HEIGHT
            });
            yPos += 1;
          }

          if (tableElement) {
            if (!hasSpace(12)) {
              yPos = await addNewPage();
              if (deptName && deptName !== lastPrintedDeptOnCurrentPage) {
                printDepartmentHeader(deptName);
              }
            }
            try {
              autoTable(doc, {
                startY: yPos,
                html: tableElement,
                theme: "grid",
                styles: {
                  fontSize: 9,
                  cellPadding: 2,
                  valign: "middle",
                  textColor: [0, 0, 0],
                  lineColor: [0, 0, 0],
                  lineWidth: 0.2
                },
                headStyles: {
                  textColor: [0, 0, 0],
                  fillColor: [255, 255, 255],
                  fontStyle: 'bold'
                },
                margin: { left: 14, right: 14, top: TOP_SAFE_Y },
                didDrawPage: (data) => {
                  if (data.pageNumber > currentPageNumber) {
                    currentPageNumber = data.pageNumber;
                    lastPrintedDeptOnCurrentPage = null;
                    addHeaderAndFooter(doc, printTypeOpt);
                    printPatientDetails(doc, patient, printTypeOpt === 'with' ? 40 : 40);
                  }
                }
              });

              yPos = doc.lastAutoTable ? doc.lastAutoTable.finalY + 6 : yPos + 17;
            } catch (err) {
              const rows = [];
              tableElement.querySelectorAll("tr").forEach(tr => {
                const cols = [];
                tr.querySelectorAll("th, td").forEach(td => cols.push((td.innerText || '').trim()));
                rows.push(cols);
              });
              if (rows.length) {
                if (!hasSpace(rows.length * 8)) {
                  yPos = await addNewPage();
                  if (deptName && deptName !== lastPrintedDeptOnCurrentPage) {
                    printDepartmentHeader(deptName);
                  }
                }
                autoTable(doc, {
                  startY: yPos,
                  body: rows,
                  theme: "grid",
                  styles: { fontSize: 9, cellPadding: 2, valign: "middle" },
                  margin: { left: 14, right: 14, top: TOP_SAFE_Y }
                });
                yPos = doc.lastAutoTable.finalY + 6;
              }
            }
          }
        } else {
          yPos += 2;
        }

        yPos += 3;
        continue;
      }

      const hasResult = param.result !== undefined && param.result !== null && String(param.result).trim() !== "";
      if (!hasResult && !isPdfStarred) {
        continue;
      }

      let resultWithFlag = hasResult ? String(param.result).trim() : "";
      let resultStyles = { halign: 'center', textColor: [0, 0, 0] };

      if (hasResult) {
        const rangeValue = formatCellValue(get_param_val(param));
        const match = String(rangeValue).match(/^\s*([\d.]+)\s*-\s*([\d.]+)\s*$/);
        if (match) {
          // Simple numeric range — auto-detect H/L
          const min = parseFloat(match[1]);
          const max = parseFloat(match[2]);
          const resultNum = parseFloat(resultWithFlag);
          if (!isNaN(resultNum)) {
            if (resultNum > max) {
              resultWithFlag = `${resultWithFlag} H`;
              resultStyles = { ...resultStyles, fontStyle: 'bold', textColor: [0, 0, 0] };
            } else if (resultNum < min) {
              resultWithFlag = `${resultWithFlag} L`;
              resultStyles = { ...resultStyles, fontStyle: 'bold', textColor: [0, 0, 0] };
            }
          }
        }
      
        // ✅ Manual bold override (works for text-type ranges like "M: 30-40 F: 60-40")
        if (param.is_bold === true) {
          resultStyles = { ...resultStyles, fontStyle: 'bold', textColor: [0, 0, 0] };
        }
      }

      paramsRows.push([
        { content: pdfParamName, styles: isPdfStarred ? { fontStyle: 'bold' } : {} },
        { content: resultWithFlag || "", styles: resultStyles },
        param.test_range_type || "",
        formatCellValue(get_param_val(param)) || "",
        param.test_param_method || ""
      ]);

      hasResultInCurrentTable = true;
    }

    const hasSampleType = !((deptName && String(deptName).toLowerCase() === 'radiology')
      || (test.params[0] && String(test.params[0].test_cat) === '60'))
      && test.params[0]?.test_sample_type;
    const sampleTypeReserve = hasSampleType ? 15 : 0;

    if (hasResultInCurrentTable) {
      await drawMainTable(paramsRows, addTableHead, deptName, test.lab_item_test_name, sampleTypeReserve, pendingDeptHeader);
      pendingDeptHeader = null;
    }

    const isRadiologyDept = (deptName && String(deptName).toLowerCase() === 'radiology')
      || (test.params[0] && String(test.params[0].test_cat) === '60');

    if (!isRadiologyDept && test.params[0]?.test_sample_type) {
      if (!hasSpace(8)) {
        yPos = await addNewPage();
        if (deptName && deptName !== lastPrintedDeptOnCurrentPage) {
          printDepartmentHeader(deptName);
        }
      }
      autoTable(doc, {
        startY: yPos,
        body: [[{
          content: `Sample Type : ${test.params[0]?.test_sample_type}`,
          colSpan: 5,
          styles: { fontStyle: 'bold', textColor: [80, 80, 80] }
        }]],
        theme: 'plain',
        styles: { fontSize: 8, cellPadding: 0.5, valign: 'middle', minCellHeight: 4 },
        margin: { left: 14, right: 14, top: TOP_SAFE_Y },
      });
      yPos = doc.lastAutoTable.finalY + 4;
    } else {
      yPos += 2;
    }

    const hasInterpretation = test.interpretation && String(test.interpretation).replace(/<[^>]*>/g, '').trim();
    const hasImpression = test.impression && String(test.impression).trim();
    const hasNotes = test.notes && String(test.notes).trim();

    const estimateHtmlHeight = (htmlStr) => {
      if (!htmlStr) return 0;
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = String(htmlStr).trim();
      const plainText = tempDiv.innerText.replace(/\u00A0/g, ' ').trim();
      const hasTable = !!tempDiv.querySelector('table');
      if (!plainText && !hasTable) return 0;
      const lines = Math.ceil(plainText.length / 80) + (hasTable ? 10 : 0);
      return Math.max(lines * 5, 15) + 15;
    };

    const interpHeight = estimateHtmlHeight(test.interpretation);
    const impressionHeight = hasImpression ? 20 : 0;
    const notesHeight = hasNotes ? 20 : 0;
    const totalInterpHeight = interpHeight + impressionHeight + notesHeight;

    if (totalInterpHeight > 0 && !hasSpace(totalInterpHeight + 5)) {
      yPos = await addNewPage();
    }

    const drawBorderedSection = async (title, htmlContent) => {
      if (!htmlContent) return;

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = String(htmlContent || '').trim();

      const plainText = tempDiv.innerText.replace(/\u00A0/g, ' ').trim();
      const hasTable = !!tempDiv.querySelector('table');
      if (!plainText && !hasTable) return;

      const startPage = doc.internal.getNumberOfPages();
      const boxTop = yPos;

      if (title) {
        if (!hasSpace(12)) {
          yPos = await addNewPage();
        }
        doc.setFontSize(9).setFont('helvetica', 'bold').text(String(title), 16, yPos + 5);
        yPos += 11;
      } else {
        if (!hasSpace(6)) {
          yPos = await addNewPage();
        }
        yPos += 2;
      }

      const nodes = Array.from(tempDiv.childNodes || []);
      for (const node of nodes) {
        if (!hasSpace(8)) {
          yPos = await addNewPage();
        }

        let tableEl = null;
        if (node.nodeType === 1) {
          const tag = node.tagName.toUpperCase();
          if (tag === 'TABLE') {
            tableEl = node;
          } else {
            const innerTable = node.querySelector && node.querySelector('table');
            if (innerTable) tableEl = innerTable;
          }
        }

        if (tableEl) {
          try {
            if (!hasSpace(12)) {
              yPos = await addNewPage();
            }

            autoTable(doc, {
              startY: yPos,
              html: tableEl,
              theme: 'grid',
              styles: {
                fontSize: 9,
                cellPadding: 2,
                valign: 'middle',
                textColor: [0, 0, 0],
                lineColor: [0, 0, 0],
                lineWidth: 0.2
              },
              headStyles: {
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
                fontStyle: 'bold'
              },
              margin: { left: 14, right: 14, top: TOP_SAFE_Y }
            });

            yPos = doc.lastAutoTable ? doc.lastAutoTable.finalY + 6 : yPos + 17;

            if (node !== tableEl) {
              const wrapperClone = node.cloneNode(true);
              const innerTbl = wrapperClone.querySelector('table');
              if (innerTbl) innerTbl.remove();
              const remainingHtml = wrapperClone.innerHTML;
              if (remainingHtml && String(remainingHtml).trim() !== '') {
                yPos = await drawHtmlContent(doc, remainingHtml, 16, yPos, {
                  maxWidth: 178,
                  addNewPage: async () => await addNewPage(),
                  pageHeight,
                  pageBuffer: SIGNATURE_AREA_HEIGHT
                });
                yPos += 4;
              }
            }
          } catch (err) {
            console.warn('autoTable html render failed, falling back', err);
            const rows = [];
            let headRow = null;
            tableEl.querySelectorAll('tr').forEach((tr, rIdx) => {
              const cells = [];
              tr.querySelectorAll('th, td').forEach(td => {
                cells.push((td.innerText || '').replace(/\u00A0/g, ' ').trim());
              });
              if (rIdx === 0 && tr.querySelectorAll('th').length > 0) {
                headRow = cells;
              } else {
                rows.push(cells);
              }
            });
            if (rows.length > 0 || headRow) {
              if (!hasSpace(rows.length * 8)) {
                yPos = await addNewPage();
              }
              autoTable(doc, {
                startY: yPos,
                head: headRow ? [headRow] : undefined,
                body: rows,
                theme: "grid",
                styles: { fontSize: 9, cellPadding: 2, valign: "middle" },
                margin: { left: 14, right: 14, top: TOP_SAFE_Y }
              });
              yPos = doc.lastAutoTable.finalY + 3;
            }
          }
        } else {
          const htmlChunk = (node.outerHTML !== undefined) ? node.outerHTML : node.nodeValue;
          if (!htmlChunk || String(htmlChunk).trim() === '') continue;

          yPos = await drawHtmlContent(doc, htmlChunk, 16, yPos, {
            maxWidth: 178,
            addNewPage: async () => {
              const newY = await addNewPage();
              return newY;
            },
            pageHeight,
            pageBuffer: SIGNATURE_AREA_HEIGHT
          });
          yPos += 4;
        }
      }

      const endPage = doc.internal.getNumberOfPages();
      if (startPage === endPage) {
        const boxHeight = Math.max(10, yPos - boxTop);
        try {
          const boxLeft = 14;
          const boxWidth = (doc.internal.pageSize.getWidth ? doc.internal.pageSize.getWidth() : doc.internal.pageSize.width) - (boxLeft * 2);
          doc.setDrawColor(0, 0, 0).setLineWidth(0.2).rect(boxLeft, boxTop, boxWidth, boxHeight);
        } catch (e) {
          console.warn("drawBorderedSection: drawing border failed:", e);
        }
      }

      yPos += 3;
    };

    await drawBorderedSection('Interpretation', test.interpretation);
    await drawBorderedSection('Impression', test.impression);
    await drawBorderedSection('Notes:', test.notes);
  }

  if (!hasSpace(12)) { yPos = await addNewPage(); }
  doc.setFontSize(12).setFont('helvetica', 'bold');
  doc.text('*** End of Report ***', pageWidth / 2, yPos + 8, { align: 'center' });

  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    if (hasRadiology) {
      await addSignatures(doc, formData.selItem['60']);
    } else {
      await addSignatures(doc, formData.selItem['32']);
    }

    doc.setFontSize(8).setTextColor(0, 0, 0);
    const pageText = `Page ${i} of ${totalPages}`;
    doc.text(pageText, pageWidth - 14, pageHeight - 20, { align: 'right' });
  }

  const pdfBlob = doc.output('blob');
  const pdfUrl = URL.createObjectURL(pdfBlob);
  const newWindow = window.open(pdfUrl, '_blank');
  if (newWindow) {
    newWindow.onload = () => { URL.revokeObjectURL(pdfUrl); };
  } else {
    const a = document.createElement('a');
    a.href = pdfUrl;
    a.download = `report_${selectedUser.lab_reg_id || 'report'}.pdf`;
    a.click();
    URL.revokeObjectURL(pdfUrl);
  }
};

// Returns true if the range is NOT a simple numeric "X-Y" range
// (i.e., gender-based or descriptive text range that can't be auto-evaluated)
const isTextRange = (param) => {
  if (!param || param.test_param_type === "Editor") return false;
  const rangeValue = formatCellValue(get_param_val(param));
  if (!rangeValue || String(rangeValue).trim() === '') return false;
  // Matches only pure "number - number" (allowing decimals/whitespace)
  const simpleNumeric = String(rangeValue).trim().match(/^\d+(\.\d+)?\s*-\s*\d+(\.\d+)?$/);
  return !simpleNumeric;
};

const isOutOfRange = (param) => {
  const value = parseFloat(param.result);
  const from = parseFloat(param.test_param_from_range);
  const to = parseFloat(param.test_param_to_range);

  if (isNaN(value) || isNaN(from) || isNaN(to)) return false;

  const min = Math.min(from, to);
  const max = Math.max(from, to);

  return value < min || value > max;
};

const isAnyResultFilled = (params) => {
  if (!params) return false;
  return params.some(param => param.result && param.result.toString().trim() !== '');
};

const handleCKEditorChange = (data, paramIndex, testIndex) => {
  setFormData(prev => {
    // Deep copy kar rahe hain taaki state immutability maintain ho
    const updatedTests = prev.l11.map((test, tIndex) => {
      if (tIndex !== testIndex) return test;

      // Current test ka params update kar rahe hain
      const updatedParams = test.params.map((param, pIndex) => {
        if (pIndex !== paramIndex) return param;
        return { ...param, result: data }; // editor ka latest content
      });

      return { ...test, params: updatedParams };
    });

    return { ...prev, l11: updatedTests };
  });
};



// console.log("Selected User:", selectedUser);

   useEffect(() => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            initData2();
        }
    }, []);

//     useEffect(() => {
//   setFilteredPatients(uniquePatients);
// }, []);

    return (
        <>
            <style>{styles}</style>
          
            <div className="page-content">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header border-0">
                                <h2 className="card-title mb-0" style={{color:"#405189"}}>Report Entry</h2>
                        </div>
                        <div className="card-body report-entry-container">
                            <form onSubmit={handleSubmit}>
                                {/* --- Filter and Patient Selection Section --- */}
                                <div className="row align-items-end gy-3 mb-4">
                                    <div className="col-md-3">
                                        <label className="form-label">From</label>
                                        <input className="form-control" type="date" name="from" onChange={handleChange} value={formData.from} />
                                    </div>
                                    <div className="col-md-3">
                                        <label className="form-label">To</label>
                                        <input className="form-control" type="date" name="to" onChange={handleChange} value={formData.to} />
                                    </div>

                                     <div className="col-md-2">
                                         <button type="button" onClick={handleSearch} className="btn btn-success w-100">Search</button>
                                     </div>
                                    <div className="col-md-4">
                                        <label className="form-label">Patient</label>
       <div className="position-relative">
       <input
  type="text"
  ref={inputRef}
  className="form-control"
  placeholder="Search Patient by Name or UHID..."
  value={searchKey}
  onChange={handleSearchInputChange}
  onFocus={() => {
    setShowSearchDropdown(true);
    setPatientPage(0);
    // If we are still loading data from server, show current filtered state (may be empty) and avoid toasts.
    if (patientsLoading) {
      // just keep filteredPatients as is — dropdown will show a "Loading..." item
      return;
    }
  
    if (!searchKey) {
      // show preloaded today's list when available else show uniquePatients
      setFilteredPatients((todaysPatients && todaysPatients.length) ? todaysPatients : uniquePatients);
      // Do not toast here — use dropdown messaging instead
    }
  }}
  
  
  onBlur={handleBlur}
  onKeyDown={handleSearchKeyDown}   // <-- ADD THIS
/>

{showSearchDropdown && (
  <ul
    className="list-group position-absolute w-100 zindex-dropdown"
    style={{ maxHeight: "250px", overflowY: "auto" }}
    ref={dropdownRef}
  >
    {patientsLoading ? (
      <li className="list-group-item">Loading patients...</li>
    ) : (paginatedPatients && paginatedPatients.length > 0) ? (
      <>
       {paginatedPatients.map((item, index) => (
  <li
    key={index}
    className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
    onMouseDown={() => handlePatientSelect(item)}
    style={{ cursor: "pointer" }}
  >
    <span>{item.lab_reg_name} ({item.lab_reg_uhid})</span>
    {item.status_badge && (
      <span dangerouslySetInnerHTML={{ __html: item.status_badge }} />
    )}
  </li>
))}

        {/* Pagination footer */}
        {totalPatientPages > 1 && (
          <li className="list-group-item d-flex justify-content-between align-items-center"
              style={{ position: "sticky", bottom: 0, background: "#f8f9fa", borderTop: "2px solid #dee2e6" }}>
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              disabled={patientPage === 0}
              onMouseDown={(e) => { e.preventDefault(); setPatientPage(p => p - 1); }}
            >
              ← Prev
            </button>
            <small className="text-muted">
              {patientPage + 1} / {totalPatientPages} ({filteredPatients.length} patients)
            </small>
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              disabled={patientPage >= totalPatientPages - 1}
              onMouseDown={(e) => { e.preventDefault(); setPatientPage(p => p + 1); }}
            >
              Next →
            </button>
          </li>
        )}
      </>
    ) : (
      <li className="list-group-item">
        No patients for the selected date. Choose a date range and click Search.
      </li>
    )}
  </ul>
)}

</div>




                                    </div>
                                    
                                </div>
                                
                                {/* --- NEW: Patient Details Section --- */}
                                {selectedUser && (
                                    <div className="patient-details-card mb-4">
                                        <table className="table">
                                            <tbody>
                                                <tr>
                                                    <td><strong>Name</strong></td>
                                                    <td>: {`${selectedUser.lab_reg_name_title ? selectedUser.lab_reg_name_title + ' ' : ''}${selectedUser.lab_reg_name}`}</td>

                                                    <td><strong>Reg. No.</strong></td>
                                                    <td>: {selectedUser.lab_reg_id}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Age/Gender</strong></td>
                                                    <td>: {selectedUser.lab_reg_age_year}Y / {selectedUser.lab_reg_gender}</td>
                                                    <td><strong>Reg. Date</strong></td>
                                                    <td>: {new Date(selectedUser.lab_reg_date).toLocaleDateString('en-GB')}
</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Ref By</strong></td>
                                                    <td>: {selectedUser.lab_reg_referral}</td>
                                                     <td><strong>UHID</strong></td>
                                                    <td>: {selectedUser.lab_reg_uhid}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                )}


{selectedUser && (
  <MachineResultImport
    selectedUser={selectedUser}
    formData={formData}
    setFormData={setFormData}
  />
)}





                             {/* --- NEW: Accordion-style Investigation & Report Table Section --- */}
                             {selectedUser && formData.l11.length > 0 && (
  // ✅ Only show "Sample not collected" message for non-radiologist roles
  (selectedUser?.lab_reg_status === "Pending" && String(ldata?.role_id || ldata?.user_role_id || '') !== '11') ? (
    <div className="alert alert-warning mt-4">
      Sample not collected
    </div>
  ) : (
                                    <div className="investigation-section-accordion mt-4">
                                        {formData.l11.map((item, index) => {
                                            const isActive = activeIndex === index;
                                            const areResultsFilled = isAllResultsFilled(item.params);
                                            return (
                                                <div className="accordion-item" key={index}>
                                                    {/* Accordion Header */}
                                                   {/* Accordion Header */}
{/* Accordion Header */}
<div
  className="accordion-header"
  role="button"
  aria-expanded={isActive ? "true" : "false"}
  onClick={() => setActiveIndex(isActive ? null : index)}
  style={{ cursor: "pointer" }}
>
 {/* Checkbox for selecting this test */}
<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
  <input
    type="checkbox"
    checked={selectedTests.has(item.lab_item_id)} // ✅ Use lab_item_id
    onChange={(e) => { e.stopPropagation(); handleToggleTestSelect(item); }}
    aria-label={`Select ${item.lab_item_test_name} for printing`}
    onClick={(e) => e.stopPropagation()}
  />
</div>

  {/* Explicit +/- button (keep separate so user can still click it) */}
  <button
    type="button"
    className={`btn accordion-toggle-btn ${isActive ? 'active' : ''}`}
    onClick={(e) => { e.stopPropagation(); setActiveIndex(isActive ? null : index); }}
    aria-label={isActive ? "Collapse" : "Expand"}
  >
    {isActive ? '−' : '+'}
  </button>

  {/* Title area — clicking this (or anywhere on header) will toggle */}
  <div className="accordion-title" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
    <span>{item.lab_item_test_name}</span>
    {item.lab_item_test_code && <small style={{ color: '#6c757d' }}>{item.lab_item_test_code}</small>}
  </div>


 {item.report_info ? (
  Number(item.report_info.is_approved) === 1 ? (
    <span className="badge bg-success">
      Approved by {item.report_info.approved_by_name}
    </span>
  ) : (
    <button
  className="btn btn-sm btn-success"
  onClick={(e) => {
    e.stopPropagation();
    handleApproveTest(item.report_info?.test_report_id, item.lab_item_id);
  }}
>
  Approve
</button>
  )
) : null}


{/* Print button - only enabled if approved */}
{/* Print button - only enabled if approved */}
<button
  type="button"
  className="btn btn-primary btn-sm"
  disabled={!item.report_info || Number(item.report_info.is_approved) !== 1}
  onClick={(e) => {
    e.stopPropagation();
    // ✅ Open modal first, then print with selected type
    setPendingPrintAction(() => (type) => generatePdfForTests([item], type));
    setShowPrintPopup(true);
  }}
>
  Print
</button>








  {/* Print button — prevent propagation so it doesn't toggle accordion */}
  {/* <button 
    type="button" 
    className="btn btn-primary btn-sm"   
    //disabled={!isAnyResultFilled(item.params) || !isReportSaved}
    onClick={(e) => { 
      e.stopPropagation();
      setPendingPrintAction(() => () => handlePrintSingleTest(item, printType));
      setShowPrintPopup(true);
    }}
  >
    Print
  </button> */}



</div>



                                                    {/* Accordion Body */}
                                                    {isActive && (
                                                        <div className="accordion-body">
                                                            <div className="table-responsive">
                                                                <table className="table table-bordered report-table">
                                                                <thead className="table-header-blue">
    <tr>
        <th style={{width: "5%"}}>S.No.</th>
        <th>Investigation Name</th>
        <th style={{width: "18%"}}>Result</th>
        <th style={{width: "6%", textAlign: "center"}}>Bold</th>
        <th style={{width: "12%"}}>Units</th>
        <th>Reference Ranges</th>
        <th style={{width: "18%"}}>Method</th>
    </tr>
</thead>
                                                                    <tbody>
                                                                    {item.params && item.params.map((param, paramIndex) => {
  // Detect if param name is wrapped by asterisks like *demo*
  const rawName = String(param.test_param_name || "");
  const isStarred = /^\*.+\*$/.test(rawName.trim());
  const displayName = isStarred ? rawName.trim().replace(/^\*(.+)\*$/, '$1') : rawName;

  return (
    <tr key={`row-${paramIndex}`}>
      <td>{paramIndex + 1}</td>
      <td style={{ fontWeight: isStarred ? 700 : 'normal' }}>{displayName}</td>

      {param.test_param_type === "Editor" ? (
        <td colSpan={4}>
          <CKEditor
            editor={ClassicEditor}
            data={param.result || get_param_val(param) || ''}
            onChange={(event, editor) => {
              const data = editor.getData();
              handleCKEditorChange(data, paramIndex, index);
            }}
          />
        </td>
      ) : (
        <>
          <td>
  {isStarred ? (
    <div style={{ padding: '6px 8px' /* match input padding a bit */ }}>
      {param.result && param.result.toString().trim() !== '' ? param.result : '—'}
    </div>
  ) : (
    // <input
    //   className={`form-control ${isOutOfRange(param) ? 'border-red' : ''}`}
    //   type={get_param_val1(param) === 1 ? "number" : "text"}
    //   value={param.result || ''}
    //   onChange={(e) => handleChange1(e, paramIndex, index)}
    // />



    <input
  className={`form-control ${isOutOfRange(param) ? 'border-red' : ''}`}
  type={get_param_val1(param) === 1 ? "number" : "text"}
  value={param.result || ''}
  onChange={(e) => handleChange1(e, paramIndex, index)}
  onWheel={(e) => {
    // prevent wheel from changing the value; keep cursor in place
    // e.preventDefault() sometimes blocked; blurring is reliable.
    // Here we prevent default (works in React) and also blur to be safe.
    e.currentTarget.blur();
    e.preventDefault();
  }}
  onKeyDown={(e) => {
    // optional: prevent non-numeric characters like 'e' which are allowed in number inputs
    if (get_param_val1(param) === 1) {
      // allow: digits, backspace, delete, arrow keys, tab, dot and minus if you want
      const allowed = [
        'Backspace','Delete','ArrowLeft','ArrowRight','Tab','Home','End'
      ];
      if (allowed.includes(e.key)) return;
      // allow dot and minus only if you want (here I allow dot)
      if (e.key === '.' || e.key === '-') return;
      if (!/^\d$/.test(e.key)) {
        e.preventDefault();
      }
    }
  }}
/>

  )}
</td>
{/* ✅ NEW: Bold checkbox — only shown for text-type ranges */}
<td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
      {isTextRange(param) && !isStarred ? (
        <input
          type="checkbox"
          checked={!!param.is_bold}
          onChange={() => handleBoldToggle(paramIndex, index)}
          title="Mark result as bold in PDF"
          style={{ width: 18, height: 18, cursor: 'pointer' }}
        />
      ) : (
        <span style={{ color: '#bbb' }}>—</span>
      )}
    </td>
          <td>{param.test_range_type}</td>
          <td>{get_param_val(param)}</td>
          <td>{param.test_param_method || ""}</td>
        </>
      )}
    </tr>
  );
})}




                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            
                                                          {/* --- Additional Notes card (collapsed by default) --- */}
<div className="row mt-4">
  <div className="col-12">
    <div className="card">
      <div
        className="card-header d-flex justify-content-between align-items-center"
        style={{ cursor: "pointer", userSelect: "none" }}
        onClick={() => toggleNotes(index)}
      >
        <div style={{ fontWeight: 600 }}>Additional Notes</div>
        <div>
          <button
            type="button"
            className="btn btn-sm btn-link"
            onClick={(e) => { e.stopPropagation(); toggleNotes(index); }}
            aria-expanded={!!openNotes[index]}
          >
            {openNotes[index] ? "−" : "+"}
          </button>
        </div>
      </div>

      {/* card body - toggled */}
      <div
        className={`card-body ${openNotes[index] ? "show" : "collapse"}`}
        style={{ display: openNotes[index] ? "block" : "none" }}
      >
        <div className="row">
          <div className="col-md-6">
            <label className="form-label">Impression</label>
            <textarea
              className="form-control"
              value={formData.l11[index].impression || ""}
              onChange={(e) => {
                const updated = [...formData.l11];
                updated[index] = { ...updated[index], impression: e.target.value };
                setFormData(prev => ({ ...prev, l11: updated }));
              }}
              placeholder="Enter Impression"
            />
          </div>

          <div className="col-md-6">
            <label className="form-label">Notes</label>
            <textarea
              className="form-control"
              value={formData.l11[index].notes || ""}
              onChange={(e) => {
                const updated = [...formData.l11];
                updated[index] = { ...updated[index], notes: e.target.value };
                setFormData(prev => ({ ...prev, l11: updated }));
              }}
              placeholder="Enter Notes"
            />
          </div>

          <div className="col-12 mt-3">
            <label className="form-label">Interpretation</label>
            <CKEditor
              editor={ClassicEditor}
              data={formData.l11[index].interpretation || ""}
              onChange={(event, editor) => {
                const data = editor.getData();
                const updated = [...formData.l11];
                updated[index] = { ...updated[index], interpretation: data };
                setFormData(prev => ({ ...prev, l11: updated }));
              }}
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

                                                            <div className="text-end mt-2">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success"
                                                                    onClick={() => handleSaveNext(index)}
                                                                   disabled={!isAnyResultFilled(item.params)}
                                                                >
                                                                    {index < formData.l11.length - 1 ? 'Save & Next' : 'Finish'}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
    )
                                )}

                                {/* --- Footer Buttons --- */}
                                <div className="text-end mt-4 d-flex justify-content-end align-items-center" style={{ gap: 8 }}>
  {/* Select All */}
  <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginRight: 8 }}>
    <input
      id="select-all-tests"
      type="checkbox"
      checked={selectAllTests}
      onChange={handleToggleSelectAll}
    />
    <label htmlFor="select-all-tests" style={{ margin: 0 }}>Select All</label>
  </div>

  {/* Print Selected */}
  <button
  type="button"
  className="btn btn-warning me-2"
  disabled={selectedTests.size === 0 || !isReportSaved}
  onClick={() => {
    // ✅ Pass type to the action so modal selection is respected
    setPendingPrintAction(() => (type) => {
      const arr = getSelectedTestsArray();
      if (!arr.length) {
        toast.info("No tests selected to print.");
        return;
      }
      generatePdfForTests(arr, type);
    });
    setShowPrintPopup(true);
  }}
>
  Print Selected
</button>

  {/* Print All (keep existing) */}
  {/* <button 
    type="button" 
    className="btn btn-info me-2"
    disabled={!isReportSaved}
    onClick={() => { 
        setPendingPrintAction(() => () => handlePrintAllTests(printType));
        setShowPrintPopup(true);
    }}
  >
    Print All Tests
  </button> */}

  {/* Save */}
  {selectedUser?.lab_reg_status !== "Pending" && (
    <button type="submit" className="btn btn-primary">
      Save Report
    </button>
  )}
</div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>

            {showPrintPopup && (
    <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
        <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">Select Print Type</h5>
                    <button 
                        type="button" 
                        className="btn-close" 
                        onClick={() => {
                            setShowPrintPopup(false);
                            setPendingPrintAction(null);
                        }}
                    ></button>
                </div>
                <div className="modal-body">
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            id="printWithout"
                            value="without"
                            checked={printType === "without"}
                            onChange={() => setPrintType("without")}
                        />
                        <label className="form-check-label" htmlFor="printWithout">
                            <strong>Without Header</strong>
                            <div className="text-muted small">Plain report — no hospital logo or footer</div>
                        </label>
                    </div>
                    <div className="form-check mt-2">
                        <input
                            className="form-check-input"
                            type="radio"
                            id="printWith"
                            value="with"
                            checked={printType === "with"}
                            onChange={() => setPrintType("with")}
                        />
                        <label className="form-check-label" htmlFor="printWith">
                            <strong>With Header</strong>
                            <div className="text-muted small">Includes hospital header and footer</div>
                        </label>
                    </div>
                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                            setShowPrintPopup(false);
                            setPendingPrintAction(null);
                        }}
                    >
                        <i className="ri-close-line me-1"></i>
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => {
                            setShowPrintPopup(false);
                            if (pendingPrintAction) {
                                // ✅ Pass current printType to the pending action
                                pendingPrintAction(printType);
                                setPendingPrintAction(null);
                            }
                        }}
                    >
                        <i className="ri-printer-line me-1"></i>
                        Confirm & Print
                    </button>
                </div>
            </div>
        </div>
    </div>
)}

        </>
    );
};

export default ReportEntry;